import { render, staticRenderFns } from "./CheckInRecords.vue?vue&type=template&id=cb71fc6e&scoped=true"
import script from "./CheckInRecords.vue?vue&type=script&lang=js"
export * from "./CheckInRecords.vue?vue&type=script&lang=js"
import style0 from "./CheckInRecords.vue?vue&type=style&index=0&id=cb71fc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb71fc6e",
  null
  
)

export default component.exports